import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { REACT_APP_API_URL, camelizeResponse, getCookie } from 'shared';
const baseQuery = fetchBaseQuery({
    baseUrl: REACT_APP_API_URL,
    prepareHeaders: async (headers) => {
        const hyperDxCookie = getCookie('__rum_sid');
        const testAutomationCookie = getCookie('TestAutomation');
        headers.set('Hyperdx-Session-Info', hyperDxCookie);
        if (testAutomationCookie) {
            headers.set('TestAutomation', testAutomationCookie);
        }
    },
});
const baseQueryWithCamelize = camelizeResponse(baseQuery);
export const api = createApi({
    reducerPath: 'affWebhooksApi',
    baseQuery: baseQueryWithCamelize,
    endpoints: () => ({}),
    keepUnusedDataFor: 0,
});
